import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { CarsMap } from '@/components/cars-map'
import { LoadingSpinner } from '@/components/loading-spinner'
import { ErrorBoundary } from '@/components/error-boundary'
import { useAuth } from '@/lib/auth-oidc'

export const Route = createFileRoute('/')({
  component: HomePage,
})

function HomePage() {
  const { isAuthenticated, isLoading, login } = useAuth()

  useEffect(() => {
    // Wait for auth to finish loading
    if (!isLoading && !isAuthenticated) {
      // User is not authenticated, redirect to login
      login()
    }
  }, [isAuthenticated, isLoading, login])

  // Show loading state while checking authentication
  if (isLoading) {
    return <LoadingSpinner variant="fullscreen" />
  }

  // Don't render the map if not authenticated (will redirect)
  if (!isAuthenticated) {
    return null
  }

  return (
    <div className="fixed-fullscreen-safe fixed">
      <ErrorBoundary
        fallback={
          <div className="flex h-full items-center justify-center bg-muted">
            <p className="text-muted-foreground">Failed to load map</p>
          </div>
        }
      >
        <CarsMap />
      </ErrorBoundary>
    </div>
  )
}
